 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		113: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","108":"vendors~css-vars-ponyfill","109":"vendors~dompurify","110":"vendors~marked","111":"vendors~polyfills"}[chunkId]||chunkId) + "." + {"0":"a31ae5e6e806b2bff230","2":"3cf49a09f6eb2c2ccf0c","3":"5f486e80bfa68ea683f0","4":"bc8493657df0e8871c5c","5":"169524381adc9ce66d2a","6":"e06ba157560c1551ffac","7":"c912556d6d0166cdcccc","8":"36372862df452e674735","9":"695cecb0589c6ef21420","10":"45d79f4a28a5930cdd6e","11":"581b409f142e546595ad","12":"02aa55e89fe283c61410","13":"5b510bf7de71f6a30c00","14":"2b1e16dff59326d73dec","15":"95c6b8f740ffebeb895e","16":"8dd6ef36a3ca986c3e9e","17":"ef7689fae9f9f34d8794","18":"bb62fa924d094f0d8df5","19":"ee2c92bf5f31bc72eda6","20":"a5a89eb0dc5e906addb8","21":"9c23000c62cec28688f3","22":"1153cfe8d71963b73927","23":"34767d72a405a273b980","24":"0ded6645fab4e27e065b","25":"af9399f134d88ca69a97","26":"a906eab23b3a0d0b67cc","27":"54d3bd2e992b43edd35d","28":"f95f7cb3dde53e58c15a","29":"5d0b0061e049497b4f9a","30":"204662c03dcbc6bd0f4d","31":"c662c38497f865957adb","32":"a04d4fd38901d1216ddf","33":"b61de595cafa312c4fca","34":"e301ce378262d4a8a8e6","35":"3d10d70642305e579b34","36":"9fcd9e3ce476b766600b","37":"bce51dd23304c40abac6","38":"246eda2d02ef3a0f0255","39":"5884c1ee6af3d4921b25","40":"690edb3c062a319c3692","41":"6b698d4816781e873961","42":"a3b5f71fdfc19f5fa31f","43":"a2904f1a8a510f78d9ce","44":"b1783e13e527ffa0102e","45":"099323cb01836408c694","46":"15baaed1ff5b0d645f5f","47":"513f27da8dcdcdaeb50f","48":"55e5e8053b0c19ca72ce","49":"f7ecee308cefe54de404","50":"7e24cca3066687d91f4a","51":"1a475e89dcce01709fcf","52":"5aa927341122abad99de","53":"980ddd69d2457cd4435c","54":"fbc250930f1687daa0a7","55":"85bf8410c694d7da5691","56":"d802d24807300af5202d","57":"72184a06daa982d23d6b","58":"d019fcede34f0d504fec","59":"ffe78179487127117765","60":"3070349ac6c38f7d5e4b","61":"7b672e3ee15eb9b2e96e","62":"3840bc99011eddcc7255","63":"2f5473d69ca71b5cfd03","64":"002a839651d950b7092b","65":"dafaf709d7a8a271b37c","66":"0f810e41b8290528c89d","67":"3e9ce9b7295d9462ac78","68":"6b5958a9dd5c0c5661a3","69":"86513bf2d2f3ef689df6","70":"b8b65bc542e827bd8a54","71":"e56f8c25bca895e956a8","72":"7eb0c6a7004af8d8663e","73":"39ffa1e7b26eacc16c9f","74":"8d87b7345673edfc09ab","75":"47a84f098a30e4a1e81f","76":"e6fe325aa8e9fe72896c","77":"609a20822736de62c226","78":"d60ec1401c5b5bf76ccd","79":"d87f1fa51dc478b43f91","80":"13fcf4470cdfc87d7601","81":"ac1c52e00a85c108c017","82":"460e613b34237d3b93ca","83":"150ff52332cc21484322","84":"0db19b31f0eaba989dd6","85":"41af56562d2e0ee39c7f","86":"a6cf2cd2fa40cc062e41","87":"5cec8cc8736b9b9dff91","88":"447d318a15914242680f","89":"50728bb4a410e4b05c1b","90":"7cff21e5c9711cbc0d70","91":"2668106da49b7fd70d3c","92":"0326b8fc11ca32b46dfc","93":"67042922d3de37560b70","94":"5d67845af62fa64b08a8","95":"9e437e6e5ceac0c2019d","96":"0fa9a8bf37263779ae69","97":"8a7d4c3eb4dd6d77d3d2","98":"df4aa18a9662a279d65a","99":"edf7d59b2eda40217dbe","100":"c9ffcf3ee6bb8a00dfe2","101":"b9bd483644485aa94505","102":"9094198fc66afe72b0b5","103":"c264070d1140f150afa9","104":"d2afef60b10fe7bc8154","105":"3f556ef12c3018d310a7","106":"d2850c2800fa5dc8b471","108":"6fa26c22d5f8fe2b504b","109":"9d7ca924d8edeb274cf5","110":"1bca08bebdf2fdb763c9","111":"6b442176dcadefcf2cf5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.227/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 93);
